import { render } from "./BestPropView.vue?vue&type=template&id=689d43c6&scoped=true"
import script from "./BestPropView.vue?vue&type=script&lang=js"
export * from "./BestPropView.vue?vue&type=script&lang=js"

import "./BestPropView.vue?vue&type=style&index=0&id=689d43c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689d43c6"]])

export default __exports__